import { assertNotEmpty } from '@festina-life/core'
import { useCallback, useMemo } from 'react'

import { isModelMetaType, rootType } from '../../types/metaModel'
import type { SubTemplateFieldValue } from '../../types/templateModel'
import { useSpecialSubTemplatedTemplatedConfigurations } from '../specialCasedSubTemplatedViewers/useSpecialSubTemplatedTemplatedConfigurations'

export const useIsSpecialCasedSubTemplatedFieldValue = () => {
  const specialConfigurations = useSpecialSubTemplatedTemplatedConfigurations()
  const specialSubTemplatedModelTypes = useMemo(
    () => Object.keys(specialConfigurations),
    [specialConfigurations],
  )

  return useCallback(
    (variant: SubTemplateFieldValue) => {
      const { subTemplatedField } = variant
      assertNotEmpty(subTemplatedField)

      const fieldRootType = isModelMetaType(
        subTemplatedField.originalPropertyType,
      )
        ? rootType(subTemplatedField.originalPropertyType)
        : undefined

      return (
        subTemplatedField.originalPropertyType &&
        fieldRootType &&
        specialSubTemplatedModelTypes.includes(fieldRootType)
      )
    },
    [specialSubTemplatedModelTypes],
  )
}
